import './YearMonthSelector.sass';
import { useState, useRef } from 'react';

const YearMonthSelector = (props) => {
	const { selectedYear, selectedMonth, updateValues } = props;

	const selector = useRef();
	const [year, setYear] = useState(new Date().getFullYear());
	const [pop, setPop] = useState('');
	const [position, setPosition] = useState({ x: 0, y: 0 });

	const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

	const clickOutside = (event) => {
		if (!selector.current.contains(event.target)) {
			setPop('');
			document.removeEventListener('mousedown', clickOutside);
		}
	};

	const openPop = () => {
		const { x, y } = selector.current.getBoundingClientRect();
		setPosition({ x, y });
		setPop('active');
		document.addEventListener('mousedown', clickOutside);
	};

	return (
		<div className='YearMonthSelector' ref={selector} onClick={openPop}>
			{selectedYear && selectedMonth && <div className='text'>{`${selectedYear}年${selectedMonth}月`}</div>}

			<div className={`pop ${pop}`} style={{ left: `${position.x}px`, top: `${position.y + 45}px` }}>
				<div className='year-wrap'>
					<div
						className='icon prev'
						onClick={() => {
							setYear(year - 1);
						}}></div>
					<div className='year'>{year}年</div>
					<div
						className='icon next'
						onClick={() => {
							setYear(year + 1);
						}}></div>
				</div>

				<div className='month-wrap'>
					{months.map((month) => {
						return (
							<div
								key={`month${month}`}
								className={`month ${selectedYear === year && selectedMonth === month && 'active'}`}
								onClick={(event) => {
									event.preventDefault();
									event.stopPropagation();
									updateValues(year, month);
									document.removeEventListener('mousedown', clickOutside);
									setPop('');
								}}>
								{month}月
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default YearMonthSelector;
